import { useEffect } from 'react';
import { EventType } from '../constants';

export const sendEvent = (
  eventType: EventType,
  detail: string | boolean | null,
) => {
  dispatchEvent(new CustomEvent(eventType, { detail }));
};

export function useEventListener(id: EventType, fn: EventListener, deps: string[] = []){
  useEffect(() => {
    window.addEventListener(id, fn)

    return () => {
      window.removeEventListener(id, fn)
    }
  }, deps);
}
